// extracted by mini-css-extract-plugin
export default {"title":"style_title__mFoXL","categoryItem":"style_categoryItem__Df-hQ","imgBlock":"style_imgBlock__FLggS","activeCategory":"style_activeCategory__raGiS"};